import { render, staticRenderFns } from "./CSVUpload.vue?vue&type=template&id=051a1318&scoped=true&"
import script from "./CSVUpload.vue?vue&type=script&lang=js&"
export * from "./CSVUpload.vue?vue&type=script&lang=js&"
import style0 from "./CSVUpload.vue?vue&type=style&index=0&id=051a1318&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051a1318",
  null
  
)

export default component.exports